import { render, staticRenderFns } from "./search-adverts-list-item-stub.vue?vue&type=template&id=73739373"
import script from "./search-adverts-list-item-stub.vue?vue&type=script&lang=ts"
export * from "./search-adverts-list-item-stub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports